import { useMutation } from "@tanstack/react-query";
import { VideoAddParams, videoAdd } from "common/api/sakusas/sakusas_video";
import { useInvalidateQueryByKeys } from "hooks/query_common/useInvalidateQueryByKeys";

type UseSakusasVideoAddParams = {
  invalidateKeys?: string[];
  successHandle?: Function;
};

export const useSakusasVideoAdd = (hookParams?: UseSakusasVideoAddParams) => {
  const { invalidateQueriesByKeys } = useInvalidateQueryByKeys();
  const { mutate: videoAddMutate } = useMutation({
    mutationFn: async (videoAddParams: VideoAddParams) =>
      await videoAdd(videoAddParams),
    onSuccess: (response) => {
      if (hookParams?.invalidateKeys) {
        invalidateQueriesByKeys(hookParams.invalidateKeys);
      }
      if (hookParams?.successHandle) {
        hookParams.successHandle(response);
      }
    },
  });

  return { videoAddMutate };
};
